import { SearchApi } from '@ps/api/search';
import {
  OrderEnumItem,
  SearchCommunityChannelMessageSortByEnumItem,
} from '@ps/api/types';
import { withClientAPI } from '@ps/functions/utils/api';

import type { ExtendedCommunityChannelMessage } from '../../types/ExtendedCommunityChannelMessage';
import { channelMessageSearchItemToMessage } from '../message/channelMessageSearchItemToMessage';

const kDefaultPageSize = 50;

/**
 * Initial page of replies under a thread anchor — chronological
 * (oldest first), so the thread reads top-to-bottom like a forum
 * discussion. Live updates layer on via Firestore
 * (`subscribeToThreadReplies`).
 *
 * Threads in chat aren't usually deep — pageSize is set generously
 * enough that most threads load in one shot.
 */
export async function fetchThreadReplies(
  creatorId: string,
  channelId: string,
  rootMessageId: string,
  {
    pageSize = kDefaultPageSize,
    cursor,
  }: { pageSize?: number; cursor?: string } = {},
): Promise<{
  replies: ExtendedCommunityChannelMessage[];
  cursor: string | undefined;
}> {
  const api = withClientAPI(SearchApi);
  const res = await api.searchApiControllerSearchStoreCommunityChannelMessages({
    storeId: creatorId,
    channelId,
    pageNo: 1,
    pageSize,
    parentMessageId: rootMessageId,
    sortBy: SearchCommunityChannelMessageSortByEnumItem.CreatedAt,
    order: OrderEnumItem.Asc,
    cursor,
  });
  return {
    replies: res.data.rows.map(row =>
      channelMessageSearchItemToMessage(channelId, row),
    ),
    cursor: res.cursor,
  };
}
